import classnames from 'classnames';
import { BottomBarIcon } from '../../types';

type ActionIconsLeftProps = {
  currentBottom: BottomBarIcon;
  toggleBottom: (item: string) => void;
  translation: any;
  isRtl?: boolean;
  hideBackpack: boolean;
};

type DisabledButtoms = {
  [key in BottomBarIcon]: boolean;
};

const ActionIconsLeft = ({
  toggleBottom,
  currentBottom,
  translation,
  isRtl,
  hideBackpack,
}: ActionIconsLeftProps) => {
  const disabled: DisabledButtoms = {
    [BottomBarIcon.Backpack]: false,
  };

  if (hideBackpack) return null;
  return (
    <div className={classnames('game-actions-bar')}>
      <div className={classnames('main-icons', currentBottom && 'categoriesOn')}>
        {!hideBackpack && (
          <div
            className={classnames('data-balloon', { 'rtl-direction': isRtl })}
            data-balloon={translation.backpack || 'Backpack'}
            data-balloon-pos="up"
          >
            <button
              className={classnames(
                'actions-btn',
                'btn',
                'game-action-button-bar',
                currentBottom === BottomBarIcon.Backpack && 'active',
              )}
              disabled={disabled[BottomBarIcon.Backpack]}
              onClick={() => {
                if (disabled[BottomBarIcon.Backpack]) return;
                toggleBottom(BottomBarIcon.Backpack);
              }}
            >
              <i className="fas fa-backpack" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionIconsLeft;
